// import React, { Component, Fragment } from 'react';
// import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import Navbar from './components/layout/Navbar';
// import Users from './components/users/Users';
// import User from './components/users/User';
// import Search from './components/users/Search';
// import Alert from './components/layout/Alert';
// import About from './components/pages/About';
// import axios from 'axios';
// import './App.css';
// export class App extends Component {
//   state = {
//     users: [],
//     repos: [],
//     user: {},
//     loading: false,
//     alert: null,
//   };

//   searchUsers = async (text) => {
//     this.setState({ loading: true });
//     const res = await axios.get(
//       `https://api.github.com/search/users?q=${text}&client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}`
//     );
//     this.setState({ users: res.data.items, loading: false });
//   };

//   getUser = async (userName) => {
//     this.setState({ loading: true });
//     const res = await axios.get(
//       `https://api.github.com/users/${userName}?client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}`
//     );
//     this.setState({ user: res.data, loading: false });
//   };
//   getUserRepos = async (userName) => {
//     this.setState({ loading: true });
//     const res = await axios.get(
//       `https://api.github.com/users/${userName}/repos?per_page=5&sort=created:asc&client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}`
//     );
//     this.setState({ repos: res.data, loading: false });
//   };

//   clearUsers = () => this.setState({ users: [], loading: false });
//   setAlert = (msg, type) => {
//     this.setState({ alert: { msg, type } });
//     setTimeout(() => {
//       this.setState({ alert: null });
//     }, 3000);
//   };
//   render() {
//     const { users, loading, user, repos } = this.state;
//     return (
//       <Router>
//         <div className='App'>
//           <Navbar title='Github Finder' icon='fa fa-github' />
//           <div className='container'>
//             <Alert alert={this.state.alert} />
//             <Switch>
//               <Route
//                 exact
//                 path='/'
//                 render={(props) => (
//                   <Fragment>
//                     <Search
//                       searchUsers={this.searchUsers}
//                       clearUsers={this.clearUsers}
//                       showClear={users.length > 0 ? true : false}
//                       setAlert={this.setAlert}
//                     />
//                     <Users loading={loading} users={users} />
//                   </Fragment>
//                 )}
//               />
//               <Route exact path='/about' component={About} />
//               <Route
//                 exact
//                 path='/user/:login'
//                 render={(props) => (
//                   <User
//                     {...props}
//                     getUser={this.getUser}
//                     getUserRepos={this.getUserRepos}
//                     user={user}
//                     repos={repos}
//                     loading={loading}
//                   />
//                 )}
//               />
//             </Switch>
//           </div>
//         </div>
//       </Router>
//     );
//   }
// }

// export default App;
//REFORMING//////////////////////////////////////////////
// import React, { useState, Fragment } from 'react';
// import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import Navbar from './components/layout/Navbar';
// import Users from './components/users/Users';
// import User from './components/users/User';
// import Search from './components/users/Search';
// import Alert from './components/layout/Alert';
// import About from './components/pages/About';
// import axios from 'axios';
// import './App.css';

// const App = () => {
//   const [users, setUsers] = useState([]);
//   const [repos, setRepos] = useState([]);
//   const [user, setUser] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [alert, setAlert] = useState(null);

//   const searchUsers = async (text) => {
//     setLoading(true);
//     const res = await axios.get(
//       `https://api.github.com/search/users?q=${text}&client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}`
//     );
//     setUsers(res.data.items);
//     setLoading(false);
//   };

//   const getUser = async (userName) => {
//     setLoading(true);
//     const res = await axios.get(
//       `https://api.github.com/users/${userName}?client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}`
//     );
//     setUser(res.data);
//     setLoading(false);
//   };

//   const getUserRepos = async (userName) => {
//     setLoading(true);
//     const res = await axios.get(
//       `https://api.github.com/users/${userName}/repos?per_page=5&sort=created:asc&client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}`
//     );
//     setRepos(res.data);
//     setLoading(false);
//   };

//   const clearUsers = () => {
//     setUsers([]);
//     setLoading(false);
//   };

//   const showAlert = (msg, type) => {
//     setAlert({ msg, type });
//     setTimeout(() => {
//       setAlert(null);
//     }, 3000);
//   };

//   return (
//     <Router>
//       <div className='App'>
//         <Navbar title='Github Finder' icon='fa fa-github' />
//         <div className='container'>
//           <Alert alert={alert} />
//           <Switch>
//             <Route
//               exact
//               path='/'
//               render={(props) => (
//                 <Fragment>
//                   <Search
//                     searchUsers={searchUsers}
//                     clearUsers={clearUsers}
//                     showClear={users.length > 0 ? true : false}
//                     setAlert={showAlert}
//                   />
//                   <Users loading={loading} users={users} />
//                 </Fragment>
//               )}
//             />
//             <Route exact path='/about' component={About} />
//             <Route
//               exact
//               path='/user/:login'
//               render={(props) => (
//                 <User
//                   {...props}
//                   getUser={getUser}
//                   getUserRepos={getUserRepos}
//                   user={user}
//                   repos={repos}
//                   loading={loading}
//                 />
//               )}
//             />
//           </Switch>
//         </div>
//       </div>
//     </Router>
//   );
// };

// export default App;
//REFORMING AFTER CONTEXT//////////////////////////////////////

// import React, { Component, Fragment } from 'react';
// import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import Navbar from './components/layout/Navbar';
// import Users from './components/users/Users';
// import User from './components/users/User';
// import Search from './components/users/Search';
// import Alert from './components/layout/Alert';
// import About from './components/pages/About';
// import axios from 'axios';
// import './App.css';
// export class App extends Component {
//   state = {
//     users: [],
//     repos: [],
//     user: {},
//     loading: false,
//     alert: null,
//   };

//   searchUsers = async (text) => {
//     this.setState({ loading: true });
//     const res = await axios.get(
//       `https://api.github.com/search/users?q=${text}&client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}`
//     );
//     this.setState({ users: res.data.items, loading: false });
//   };

//   getUser = async (userName) => {
//     this.setState({ loading: true });
//     const res = await axios.get(
//       `https://api.github.com/users/${userName}?client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}`
//     );
//     this.setState({ user: res.data, loading: false });
//   };
//   getUserRepos = async (userName) => {
//     this.setState({ loading: true });
//     const res = await axios.get(
//       `https://api.github.com/users/${userName}/repos?per_page=5&sort=created:asc&client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}`
//     );
//     this.setState({ repos: res.data, loading: false });
//   };

//   clearUsers = () => this.setState({ users: [], loading: false });
//   setAlert = (msg, type) => {
//     this.setState({ alert: { msg, type } });
//     setTimeout(() => {
//       this.setState({ alert: null });
//     }, 3000);
//   };
//   render() {
//     const { users, loading, user, repos } = this.state;
//     return (
//       <Router>
//         <div className='App'>
//           <Navbar title='Github Finder' icon='fa fa-github' />
//           <div className='container'>
//             <Alert alert={this.state.alert} />
//             <Switch>
//               <Route
//                 exact
//                 path='/'
//                 render={(props) => (
//                   <Fragment>
//                     <Search
//                       searchUsers={this.searchUsers}
//                       clearUsers={this.clearUsers}
//                       showClear={users.length > 0 ? true : false}
//                       setAlert={this.setAlert}
//                     />
//                     <Users loading={loading} users={users} />
//                   </Fragment>
//                 )}
//               />
//               <Route exact path='/about' component={About} />
//               <Route
//                 exact
//                 path='/user/:login'
//                 render={(props) => (
//                   <User
//                     {...props}
//                     getUser={this.getUser}
//                     getUserRepos={this.getUserRepos}
//                     user={user}
//                     repos={repos}
//                     loading={loading}
//                   />
//                 )}
//               />
//             </Switch>
//           </div>
//         </div>
//       </Router>
//     );
//   }
// }

// export default App;
//REFORMING//////////////////////////////////////////////
import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Home from './components/pages/Home';
import User from './components/users/User';

import Alert from './components/layout/Alert';
import About from './components/pages/About';
import NotFound from './components/pages/NotFound';
import GithubState from './context/github/GithubState';
import AlertState from './context/alert/AlertState';
import './App.css';

const App = () => {
  return (
    <GithubState>
      <AlertState>
        <Router>
          <div className='App'>
            <Navbar title='Github Finder' icon='fa fa-github' />
            <div className='container'>
              <Alert />
              <Switch>
                <Route exact path='/' component={Home} />
                <Route exact path='/about' component={About} />
                <Route exact path='/user/:login' component={User} />
                <Route component={NotFound} />
              </Switch>
            </div>
          </div>
        </Router>
      </AlertState>
    </GithubState>
  );
};

export default App;
